import { stripHtmlTags } from 'src/model/helpers';
import providersService from 'src/services/providers.service';

const moment = require('moment');

const filtersMixin = {
    methods: {
        formatTel (tel) {
            if (!tel) {
                return tel;
            }
            if (tel.length === 0) {
                return tel;
            }
            tel = tel.replace(/[^0-9]/g, '');
            if (tel[0] !== '7' && tel.length < 11) {
                tel = `7${tel}`;
            }
            if (tel[0] === '7' && tel.length === 11) {
                tel = `+7 (${tel.slice(1, 4)}) ${tel.slice(4, 7)}-${tel.slice(7, 9)}-${tel.slice(9, 11)}`;
            }
            if (tel[0] !== '7' && tel.length === 11) {
                tel = `+${tel[0]} (${tel.slice(1, 4)}) ${tel.slice(4, 7)}-${tel.slice(7, 9)}-${tel.slice(9, 11)}`;
            }
            return tel;
        },
        formatMonths (count) {
            if (!count) {
                return undefined;
            }
            count = +count;
            let result = `${count} месяцев`;
            const i = count % 20;
            if (i === 1) {
                result = `${count} месяц`;
            }
            if (i >= 2 && i < 5) {
                result = `${count} месяца`;
            }
            if (i >= 5 && i < 20) {
                result = `${count} месяцев`;
            }
            return result;
        },
        formatDays (count) {
            if (!count) {
                return undefined;
            }
            count = +count;
            let result = `${count} дней`;
            const i = count % 20;
            if (i === 1) {
                result = `${count} день`;
            }
            if (i >= 2 && i < 5) {
                result = `${count} дня`;
            }
            if (i >= 5 && i < 20) {
                result = `${count} дней`;
            }
            return result;
        },
        formatDateShort (v) {
            const m = moment(v);
            if (!m.isValid()) {
                return '';
            }
            return m.format('DD.MM.YYYY');
        },
        formatDateTimeShort (v) {
            const m = moment(v);
            if (!m.isValid()) {
                return '';
            }
            if (m.format('HH:mm') === '00:00') {
                return m.format('DD.MM.YYYY');
            }
            return m.format('DD.MM.YYYY HH:mm');
        },
        formatDateShortNoYear (v) {
            const date = moment(v);
            const now = moment();
            if (!date.isValid()) {
                return undefined;
            }
            if (date.format('YYYY') === now.format('YYYY')) {
                return date.locale('ru').format('DD MMM');
            }
            return date.format('DD.MM.YYYY');
        },
        formatDateShortNoYearTime (v) {
            const date = moment(v);
            const now = moment();
            if (!date.isValid()) {
                return '';
            }
            if (date.format('YYYY') === now.format('YYYY')) {
                return date.locale('ru').format('DD MMM HH:mm');
            }
            return date.format('DD.MM.YYYY HH:mm');
        },
        formatDateTime (v) {
            if (!v) {
                return undefined;
            }
            if (v === 'null') {
                return undefined;
            }
            if (v === '0000-00-00 00:00:00') {
                return undefined;
            }
            return moment(v).format('DD.MM.YYYY HH:mm');
        },
        formatDateToDayOfWeek (v) {
            const m = moment(v).locale('ru');
            if (!m.isValid()) {
                return '';
            }
            if (m.year() !== moment().year()) {
                return m.format('DD MMMM YYYY');
            }
            return m.format('DD MMMM');
        },
        formatDateNoYear (v) {
            const m = moment(v).locale('ru');
            if (!m.isValid()) {
                return '';
            }
            return m.format('DD.MM');
        },
        formatDateYear (v) {
            const m = moment(v).locale('ru');
            if (!m.isValid()) {
                return '';
            }
            return m.format('DD.MM.YY');
        },
        formatDateMaybeYear (v) {
            if (!v) { return ''; }
            const m = moment(v).locale('ru');
            if (!m.isValid()) {
                return '';
            }
            if (m.year() === moment().year()) {
                return m.format('DD.MM');
            }
            return m.format('DD.MM.YY');
        },
        formatDateForTaskMobile (v) {
            const d = moment(v);
            if (!d.isValid()) return '';

            const hhmm = d.format('HH:mm');
            if (hhmm === '00:00') {
                return {
                    date: d.format('DD'),
                    monthAndYear: d.format('MM.YY'),
                };
            }
            return {
                date: d.format('DD'),
                monthAndYear: d.format('MM.YY'),
                time: d.format('HH:mm'),
            };
        },
        formatDateToDayOfWeekFull (v) {
            const m = moment(v).locale('ru');
            if (!m.isValid()) return '';

            const firstPart = `${this.formatDateToDayOfWeek(v).split(' ').join('&nbsp;')}`;
            const hhmm = m.format('HH:mm');
            const secondPart = hhmm === '00:00' ? '' : ` ${m.format('HH:mm')}&nbsp;МСК`;
            return `${firstPart}${secondPart}`;
        },
        formatPrice (v) {
            if (!v) {
                return '0 ₽';
            }
            const d = parseFloat(v).toFixed(2);
            const s = (+d).toLocaleString();
            return `${s} ₽`;
        },
        formatPriceNoZero (v) {
            if (!v) {
                return '';
            }
            const d = parseFloat(v).toFixed(0);
            const s = (+d).toLocaleString();
            return `${s} ₽`;
        },
        formatPriceNoRub (v) {
            if (!v) {
                return '';
            }
            const d = parseFloat(v).toFixed(2);
            const s = (+d).toLocaleString();
            return `${s}`;
        },
        formatSeconds (secs) {
            return moment.utc(secs * 1000).format('HH:mm:ss');
        },
        formatSec (value) {
            value = +value;
            const m = Math.floor(value / 60).toString().padStart(2, '0');
            const s = Math.round(value - (m * 60)).toString().padStart(2, '0');
            return `${m} м ${s} с`;
        },
        formatSecOnlyMin (value) {
            const duration = moment.duration(value, 'seconds');
            // value = +value;
            // const m = Math.floor(value / 60).toString().padStart(2, '0');
            // const s = Math.round(value - (m * 60)).toString().padStart(2, '0');
            if (value >= 60) return `${Number.parseInt(duration.asMinutes(), 10)} мин`;
            return `${duration.asSeconds()} сек.`;
        },
        getAge (date) {
            const d1 = moment(date);
            const now = moment();
            const years = now.diff(d1, 'year');
            return this.ageToStr(years);
        },
        getGender (gender) {
            if (gender === '1') {
                return 'мужской';
            }
            return 'женский';
        },
        ageToStr (age) {
            if (_.isNaN(age)) return '';
            const titles = ['год', 'года', 'лет'];
            const cases = [2, 0, 1, 1, 1, 2];
            const word = titles[(age % 100 > 4 && age % 100 < 20) ? 2 : cases[(age % 10 < 5) ? age % 10 : 5]];
            return `${age} ${word}`;
        },
        statusShown (status) {
            const i = +status;
            switch (i) {
                case 0:
                    return 'Новый';
                case 1:
                    return 'Обучение';
                case 2:
                    return 'Отказ';
                case 3:
                    return 'Диплом';
                case 4:
                    return 'Успех';
                default:
                    return '';
            }
        },
        schoolStatusShown (status) {
            const i = +status;
            switch (i) {
                case 0:
                    return 'Новый';
                case 1:
                    return 'Акивный';
                case 2:
                    return 'Отказ';
                case 3:
                    return 'Архив';
                default:
                    return 'Новый';
            }
        },
        statusIcon (status) {
            const i = +status;
            switch (i) {
                case 0:
                    return 'schedule';
                case 1:
                    return 'school';
                case 2:
                    return 'block';
                case 3:
                    return 'stars';
                case 4:
                    return 'attach_money';
                default:
                    return '';
            }
        },
        statusColor (status) {
            const i = +status;
            switch (i) {
                case 0:
                    return 'grey';
                case 1:
                    return 'primary';
                case 2:
                    return 'negative';
                case 3:
                    return '#726ba7';
                case 4:
                    return 'info';
                default:
                    return '';
            }
        },
        categoryName (code) {
            switch (code) {
                case '1.100':
                    return 'инвалид';
                case '2.100':
                    return 'безработный';
                case '3.75':
                    return 'безработный';
                case '4.75':
                    return 'родитель';
                case '5.50':
                    return 'родитель';
                case '6.50':
                    return 'студент';
                case '7.50':
                    return 'бюджет';
                case '8.50':
                    return 'малоимущий';
                case '100.0':
                    return 'герой';
                default:
                    return '';
            }
        },
        formatDateTimeQuoted (dateString) {
            const date = moment(dateString, 'DD.MM.YYYY HH:mm');
            if (!date.isValid()) {
                return 'NULL';
            }
            const s = date.format('YYYY-MM-DD HH:mm');
            return `'${s}'`;
        },
        getDocTypeShown (type) {
            switch (type) {
                case 'retrain':
                    return 'Диплом о профессиональной переподготовке';
                case 'advance':
                    return 'Удостоверение о повышении квалификации';
                default:
                    return '';
            }
        },
        getAddProgShown (type) {
            switch (type) {
                case 'advance':
                    return 'Повышение квалификации';
                case 'retrain':
                    return 'Профессиональная переподготовка';
                default:
                    return '';
            }
        },
        getFilename (path) {
            if (!path) {
                return path;
            }
            if (!String(path).startsWith('http')) {
                return path;
            }

            // eslint-disable-next-line no-useless-escape
            return path.replace(/^.*[\\\/]/, '');
        },
        humanFileSize (size) {
            if (!size) {
                return '';
            }
            const i = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024));
            // eslint-disable-next-line no-restricted-properties
            return `${(size / Math.pow(1024, i)).toFixed(2) * 1} ${['байт', 'КБ', 'МБ', 'ГБ', 'ТБ'][i]}`;
        },
        formatDateIntervalHint (filter) {
            if (!filter) {
                return undefined;
            }
            if (filter.from && filter.to) {
                const from = moment(filter.from).format('DD.MM.YYYY');
                const to = moment(filter.to).format('DD.MM.YYYY');
                return `${from} - ${to}`;
            }
            const d = moment(filter, 'YYYY/MM/DD', true);
            if (d.isValid()) {
                return d.format('DD.MM.YYYY');
            }
            return filter;
        },
        getDefaultAvatar (user) {
            const zodiacSigns = [
                'Capricorn.svg', // 0 Козерог
                'Aqvarius.svg', // 1 Водолей
                'Pisces.svg', // 2 Рыбы
                'Aries.svg', // 3 Овен
                'Taurus.svg', // 4 Телец
                'Gemini.svg', // 5 Близнецы
                'Cancer.svg', // 6 Рак
                'Leo.svg', // 7 Лев
                'Virgo.svg', // 8 Дева
                'Libra.svg', // 9 Весы
                'Scorpio.svg', // 10 Скорпион
                'Sagittarius.svg', // 11 Стрелец
            ];
            if (!user) {
                return 'new-icons/User Male.svg';
            }
            const { birthday } = user;
            const { gender } = user;
            if (!birthday && !gender) {
                return 'new-icons/User Male.svg';
            }

            const b = moment(birthday, 'YYYY-MM-DD');
            if (b.isValid()) {
                const month = b.month() + 1;
                const day = b.date();
                let zodiac;
                // Овен
                if ((month === 3 && day >= 21) || (month === 4 && day <= 20)) {
                    // eslint-disable-next-line prefer-destructuring
                    zodiac = zodiacSigns[3];
                }
                // Телец
                if ((month === 4 && day >= 21) || (month === 5 && day <= 21)) {
                    // eslint-disable-next-line prefer-destructuring
                    zodiac = zodiacSigns[4];
                }
                // Близнецы
                if ((month === 5 && day >= 22) || (month === 6 && day <= 21)) {
                    // eslint-disable-next-line prefer-destructuring
                    zodiac = zodiacSigns[5];
                }
                // Рак
                if ((month === 6 && day >= 22) || (month === 7 && day <= 22)) {
                    // eslint-disable-next-line prefer-destructuring
                    zodiac = zodiacSigns[6];
                }
                // Лев
                if ((month === 7 && day >= 23) || (month === 8 && day <= 21)) {
                    // eslint-disable-next-line prefer-destructuring
                    zodiac = zodiacSigns[7];
                }
                // Дева
                if ((month === 8 && day >= 22) || (month === 9 && day <= 23)) {
                    // eslint-disable-next-line prefer-destructuring
                    zodiac = zodiacSigns[8];
                }
                // Весы
                if ((month === 9 && day >= 24) || (month === 10 && day <= 23)) {
                    // eslint-disable-next-line prefer-destructuring
                    zodiac = zodiacSigns[9];
                }
                // Скорпион
                if ((month === 10 && day >= 24) || (month === 11 && day <= 22)) {
                    // eslint-disable-next-line prefer-destructuring
                    zodiac = zodiacSigns[10];
                }
                // Стрелец
                if ((month === 11 && day >= 23) || (month === 12 && day <= 22)) {
                    // eslint-disable-next-line prefer-destructuring
                    zodiac = zodiacSigns[11];
                }
                // Козерог
                if ((month === 12 && day >= 23) || (month === 1 && day <= 20)) {
                    // eslint-disable-next-line prefer-destructuring
                    zodiac = zodiacSigns[0];
                }
                // Водолей
                if ((month === 1 && day >= 21) || (month === 2 && day <= 19)) {
                    // eslint-disable-next-line prefer-destructuring
                    zodiac = zodiacSigns[1];
                }
                // Рыбы
                if ((month === 2 && day >= 20) || (month === 3 && day <= 20)) {
                    // eslint-disable-next-line prefer-destructuring
                    zodiac = zodiacSigns[2];
                }

                if (!zodiac) {
                    return undefined;
                }
                // const zodiacIndex = (month + (day < 20 ? 11 : 12)) % 12;
                // const zodiac = zodiacSigns[zodiacIndex];
                return `new-icons/horoscope/${zodiac}`;
            }

            return +gender === 1 ? 'new-icons/User Male.svg' : 'new-icons/User Female.svg';
        },
        getStatusShown (status) {
            let result = 'ОК';
            if (status === 'empty') {
                result = 'Пусто';
            }
            if (status === 'dup-internal') {
                result = 'Дубляж внутренний';
            }
            if (status === 'dup-external') {
                result = 'Дубляж внешний';
            }
            if (status === 'rich') {
                result = 'Обогащен';
            }
            return result;
        },
        getQuestionTypeShown (v) {
            switch (v) {
                case 'input':
                    return 'Строка';
                case 'options':
                    return 'Выбор';
                case 't-poll-single':
                    return 'Т-одиночный';
                case 't-poll-multi':
                    return 'Множественный';
                case 'photo':
                    return 'Картинка';
                case 'file':
                    return 'Файл';
                case 'chat':
                    return 'Операторский';
                case 'exercise':
                    return 'Задание';
                default:
                    return v;
            }
        },
        stripTags (v) {
            return stripHtmlTags(v);
        },
        formatProvider (provider) {
            const providers = providersService.list();
            const [p] = providers.filter((i) => i.value === provider);
            return p?.label || provider;
        },
        validateNumber (val, min, max) {
            if (!val) {
                return true;
            }
            const i = Number(val);
            if (Number.isNaN(i)) {
                return false;
            }
            if (!min && !max) {
                return true;
            }
            if (min !== undefined && i < min) {
                return false;
            }
            if (max !== undefined && i > max) {
                return false;
            }
            return true;
        },
        validateDate (val, format) {
            const m = moment(val, format, true);
            return m.isValid();
        },
        validateInterval (val) {
            if (!val) {
                return true;
            }
            let result = false;
            if (val.includes('....')) {
                return false;
            }
            if (window.intervals.has(val)) {
                window.intervals.delims.forEach((delim) => {
                    if (val.includes(delim)) {
                        // min... >=
                        // ...max <=
                        // min...max >= <=
                        const arr = val.split(delim);
                        if (arr.length === 1) {
                            result = Number.isFinite(Number(arr[0]));
                        }
                        if (arr.length === 2) {
                            result = Number.isFinite(Number(arr[0])) && Number.isFinite(Number(arr[1]));
                        }
                    }
                });
                return result;
            }
            return Number.isFinite(Number(val));
        },
        getCourseIconPath (alias) {
            return `new-icons/courses/${alias}.svg`;
        },
        isNumber (val) {
            return Number.isFinite(Number(val));
        },
        getAppTransfertStatusShown (status) {
            switch (status) {
                case 'activated':
                    return 'Активирован';
                case 'conditionally_activated':
                    return 'Активирован условно';
                case 'revoked':
                    return 'Аннулирован';
                case 'booked':
                    return 'Забронирован';
                case 'closed':
                    return 'Активирован';
                case 'awaiting_closure':
                    return 'Активирован';
                case 'К погашению':
                    return 'Активирован';
                case 'Погашен':
                    return 'Активирован';
                default:
                    return status;
            }
        },
        shortSentence (text, maxWords = 3) {
            if (!text) {
                return text;
            }
            const a = text.split(' ');
            let result = a.slice(0, maxWords).join(' ');
            if (a.length > maxWords) {
                result += '...';
            }
            return result;
        },
        shortText (text, maxLength = 3) {
            if (!text) {
                return text;
            }
            let result = text.slice(0, maxLength);
            if (text.length > maxLength) {
                result += '...';
            }
            return result;
        },
    },
};

export default filtersMixin;
